<template>
  <div class="registration-form">
    <page-header title="Basic Information" breadcrumb="Dashboard > CRM > Customer Registration " />

    <div class="card">
      <div class="flex justify-between">
        <div>
          <p class="text-deepBlue font-semibold">Basic Information</p>
        </div>
        <div>
          <img src="@/assets/images/icons/info.svg" alt="information icon" />
        </div>
      </div>

      <div class="flex items-center">
        <img src="@/assets/images/profile-img.png" alt="Profile image" />
        <p>Upload Photo</p>
      </div>

      <div class="basic-info-form container-fluid">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Name:</label>
            <input type="text" class="input" placeholder="Enter customer name" v-model="customer.name" />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Email:</label>
            <email-input placeholder="Enter email address" v-model="customer.email" />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Type:</label>
            <el-select v-model="customer.kind" placeholder="Individual/Organization">
              <el-option v-for="kind in customerKinds" :key="kind" :label="kind" :value="kind">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">MuleEx ID:</label>
            <input type="text" class="input" placeholder="MuleEx ID" :disabled="true" />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Industry Sector:</label>
            <el-select v-model="customer.industrySector" placeholder="Select">
              <el-option v-for="industry in industries" :key="industry" :label="industry" :value="industry">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Profile Information:</label>
            <input type="text" class="input" placeholder="Select" v-model="customer.profile" />
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Loyalty Scheme:
              <span class="text-xs underline cursor-pointer" @click="isLoyaltySchemeModal = true">Set Up a Loyalty
                Scheme</span></label>
            <el-select v-model="customer.loyaltySchemeId" placeholder="Select">
              <el-option v-for="scheme in loyaltySchemes" :key="scheme.id" :label="scheme.loyaltyCategory"
                :value="scheme.id">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Price Reference:</label>
            <el-select v-model="customer.contactCategory" placeholder="Select">
              <el-option v-for="preference in pricePreferences" :key="preference" :label="preference"
                :value="preference">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <label class="label">Lead Status:</label>
            <el-select v-model="customer.leadStatus" placeholder="Select">
              <el-option v-for="status in leadStatuses" :key="status" :label="status" :value="status">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4" v-if="customer.kind == 'individual'">
            <label class="label">Gender:</label>
            <el-select v-model="customer.gender" placeholder="Select">
              <el-option v-for="gender in genders" :key="gender" :label="gender" :value="gender">
              </el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-lg-4" v-if="customer.kind == 'individual'">
            <label class="label">Birthday:</label>
            <el-date-picker v-model="customer.birthday" type="date" placeholder="Pick a day">
            </el-date-picker>
          </div>
        </div>
      </div>

      <div class="billing-address">
        <div class="pt-5">
          <p class="text-deepBlue font-semibold">Contact Information</p>
          <p class="text-sm">* This is the customer’s billing address</p>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4" v-if="customer.kind == 'organization'">
              <label class="label">Contact Person:</label>
              <input type="text" class="input" placeholder="Enter contact person" v-model="customer.contactPerson" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Phone Number:</label>
              <input type="text" class="input" placeholder="Enter phone number" v-model="customer.phone" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Country:</label>
              <country-dropdown @change="customer.country = $event" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Address:</label>
              <vue-google-autocomplete id="map2" ref="customerAddress" classname="input" placeholder="Enter address"
                v-on:placechanged="customer.address">
              </vue-google-autocomplete>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">State:</label>
              <state-dropdown @change="customer.state = $event" @save-cities="cities = $event" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">City:</label>
              <city-dropdown :cities="cities" @change="customer.city = $event" />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Zip/Postal Code:</label>
              <input type="text" class="input" placeholder="Enter zip code" v-model="customer.zipCode" />
            </div>
          </div>
        </div>
        <div class="flex items-center">
          <input type="checkbox" id="same-address" v-model="isSameBillingAddress" />
          <label class="text-sm pl-2" for="same-address">Billing Address same as Delivery Address</label>
        </div>
      </div>

      <div class="delivery-address" v-if="isSameBillingAddress || customer.deliveryAddress.length">
        <div class="pt-5 pb-4">
          <p class="text-deepBlue font-semibold">Delivery Addresses</p>
        </div>
        <div class="table-wrapper">
          <table class="address-table">
            <thead>
              <tr>
                <th>Default</th>
                <th>Phone</th>
                <th>Country</th>
                <th>Address</th>
                <th>State</th>
                <th>City</th>
                <th>Zip/Postal Code</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(address, index) in customer.deliveryAddress" :key="index">
                <td class="radio-td">
                  <!-- <input type="radio" /> -->
                  <radio-input :id="`default-address${index}`" :value="true" label=""
                    v-model="address.isDefaultAddress" />
                </td>
                <td>
                  <input type="text" class="input" v-model="address.phone" />
                </td>
                <td>
                  <el-select v-model="address.country" placeholder="Select country">
                    <el-option v-for="country in countries" :key="country" :label="country" :value="country">
                    </el-option>
                  </el-select>
                </td>
                <td>
                  <vue-google-autocomplete id="map2" ref="shipperAddress" :value="address.location"
                    classname="input" placeholder="Enter address" v-on:placechanged="getDAddress($event, index)">
                  </vue-google-autocomplete>
                </td>
                <td>
                  <el-select v-model="address.state" placeholder="Select state"
                    @change="getCitiesInState(address.state, index)">
                    <el-option v-for="state in states" :key="state.name" :label="state.name" :value="state.name">
                    </el-option>
                  </el-select>
                </td>
                <td>
                  <el-select v-model="address.city" placeholder="Select city">
                    <el-option v-for="city in address.cities" :key="city" :label="city" :value="city">
                    </el-option>
                  </el-select>
                </td>
                <td>
                  <input type="text" class="input" v-model="address.zipCode" />
                </td>
                <td class="address-action font-semibold text-deepBlue cursor-pointer" @click="removeAddress(index)">
                  <span v-if="customer.deliveryAddress.length > 1">Remove</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="flex items-center cursor-pointer py-4" @click="addDeliveryAddress">
        <span><svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.9998 0C5.37259 0 0 5.37267 0 11.9999C0 18.6269 5.37251 24 11.9996 24C18.6268 24 23.9998 18.6269 23.9998 11.9999C23.9998 5.37267 18.6269 0 11.9998 0ZM17.0622 13.3199H13.2007V17.3574C13.2004 18.0345 12.6516 18.5833 11.9744 18.5833C11.297 18.5833 10.7482 18.0345 10.7482 17.357V13.3199H6.98945C6.31218 13.3197 5.76362 12.7709 5.76322 12.0937C5.76322 11.4167 6.31226 10.8677 6.98945 10.8675L10.7481 10.8677V7.28449C10.7481 6.60721 11.2972 6.05826 11.9742 6.05826C12.6516 6.05826 13.2007 6.60729 13.2004 7.28449L13.2007 10.8674L17.0618 10.8678C17.7391 10.8674 18.2883 11.4166 18.2881 12.094C18.2883 12.7713 17.7391 13.3199 17.0622 13.3199Z"
              fill="#E59506" />
          </svg>
        </span>
        <span class="pl-2 font-semibold cursor-pointer text-gold">Add Delivery Address</span>
      </div>

      <div class="other-information">
        <p class="text-deepBlue font-semibold">Other Information</p>
        <div class="container-fluid">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <label class="label">Other</label>
              <input type="text" class="input" />
            </div>
          </div>
        </div>
      </div>

      <div class="actions flex justify-between">
        <div class="cursor-pointer" @click="$router.push({ name: 'CRM' })">
          <p>Cancel</p>
        </div>
        <div>
          <primary-button buttonText="Save" :loading="loading" @click="saveCustomerInformation" />
        </div>
      </div>
    </div>

    <loyalty-scheme-form :show-modal="isLoyaltySchemeModal" @close-modal="isLoyaltySchemeModal = false"
      @scheme-created="getAllLoyaltySchemes" />
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import CountryDropdown from "@/components/UI/CountryDropdown";
import StateDropdown from "@/components/UI/StateDropdown";
import CityDropdown from "@/components/UI/CityDropdown";
import LoyaltySchemeForm from "./Modals/CreateLoyaltyScheme";
import VueGoogleAutocomplete from "vue-google-autocomplete";

import { industries } from "@/utilities/globalVariables.js";

export default {
  components: {
    PageHeader,
    CountryDropdown,
    StateDropdown,
    CityDropdown,
    LoyaltySchemeForm,
    VueGoogleAutocomplete,
  },
  data() {
    return {
      customer: {
        // statusDescription: "none",
        email: "",
        isDualCategory: true,
        name: "",
        category: "customer",
        registeredBy: "self",
        contactCreatorType: "in-house",
        // supplierOrgId: null,
        // userParentId: null,
        kind: "individual",
        contactCategory: "retail",
        gender: "",
        profile: "",
        industrySector: "",
        // specialization: "specialization",
        address: "",
        // location: "location",
        leadStatus: "",
        country: "",
        state: "",
        city: "",
        zipCode: "",
        contactPerson: "",
        phone: "",
        birthday: "",
        loyaltySchemeId: null,
        // taxSettings: "N/A",
        // taxId: null,
        deliveryAddress: [],
        accountManager: [],
        manageException: [],
      },
      customerKinds: ["individual", "organization"],
      genders: ["Female", "Male", "Others"],
      countries: ["Nigeria"],
      states: [],
      industries: industries,
      leadStatuses: ["new", "qualified", "unqualified"],
      loyaltySchemes: [],
      pricePreferences: ["retail", "wholesale"],
      cities: [],
      deliveryAddressCities: [],
      loading: false,
      isSameBillingAddress: false,
      isNewDeliveryAddress: false,
      isLoyaltySchemeModal: false,
    };
  },
  watch: {
    isSameBillingAddress(val) {
      if (val) {
        this.addDeliveryAddress();
        let { deliveryAddress } = this.customer;
        let {
          phone,
          address,
          country,
          state,
          city,
          zipCode,
          contactPerson,
          name,
        } = this.customer;
        // console.log(deliveryAddress);
        // console.log(deliveryAddress[0].location);
        // console.log(address, country, state, city, zipCode, contactPerson);
        deliveryAddress[0].phone = phone;
        deliveryAddress[0].location = address;
        deliveryAddress[0].country = country;
        deliveryAddress[0].state = state;
        deliveryAddress[0].city = city;
        deliveryAddress[0].zipCode = zipCode;
        deliveryAddress[0].contactPerson = contactPerson.length
          ? contactPerson
          : name;
        deliveryAddress[0].cities = [];
      } else {
        this.customer.deliveryAddress = [];
      }
    },
  },
  mounted() {
    this.getAllStatesAndCities();
    this.getAllLoyaltySchemes();
  },
  methods: {
    getDAddress(addressData, index) {
      this.customer.deliveryAddress[index].location.name = addressData.route
      this.customer.deliveryAddress[index].location.lat = addressData.latitude;
      this.customer.deliveryAddress[index].location.lng = addressData.longitude;
      // this.shipper.country = addressData.country;
    },
    async saveCustomerInformation() {
      this.loading = true;
      const orgId = localStorage.getItem("organizationId");
      if (this.customer.kind == "individual") {
        delete this.customer.contactPerson;
      } else {
        delete this.customer.gender;
        delete this.customer.birthday;
      }
      console.log(orgId);
      const payload = {
        userInfo: {
          orgId: orgId,
          outletId: null,
          creatorId: orgId,
        },
        payload: this.customer,
      };
      try {
        const response = await this.$_saveCustomerInformation(payload);
        console.log(response);
        this.generateToast("Customer registered successfully!", "success");
        this.$router.push({ name: "CRM" });
      } catch (error) {
        this.handleError(error);
      }
      this.loading = false;
    },
    async getAllLoyaltySchemes() {
      try {
        const response = await this.$_getAllLoyaltySchemes();
        this.logResponse(response);
        this.loyaltySchemes = response.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    addDeliveryAddress() {
      let newDeliveryAddress = {
        location: "",
        country: "",
        state: "",
        city: "",
        zipCode: "",
        contactPerson: "",
        cities: [],
      };
      this.customer.deliveryAddress.push(newDeliveryAddress);
    },
    removeAddress(index) {
      this.customer.deliveryAddress.splice(index, 1);
    },
    async getAllStates() {
      try {
        let response = await this.$_getAllStates();
        console.log(response);
        this.states = response.data.findState;
        // this.getCitiesInState();
      } catch (error) {
        this.handleError(error);
      }
    },
    getCitiesInState(state, index) {
      // if (this.selectedState.length) {
      // let formattedStateName = state
      //   .replace(/\s/g, "")
      //   .replace("State", "")
      //   .toLowerCase();
      // this.getCities(formattedStateName, index);
      this.getCities(state, index);

      // }
    },
    async getCities(stateName, index = null) {
      try {
        this.cities = [];
        if (stateName?.length > 0) {
          this.customer.deliveryAddress[index].cities = [...this.states.find(state => state.name == stateName).cities]
        }
        // let response = await this.$_getCities(stateName);
        // this.deliveryAddress[index].cities = response.data.allCities;
      } catch (error) {
        this.handleError(error);
      }
    },
    getAddress(addressData) {
      this.customer.address = addressData.route;
    },
    // handleChange() {
    //   this.$emit("change", this.selectedState);
    //   this.getCitiesInState();
    // },
  },
};
</script>

<style scoped>
.el-select {
  margin-bottom: 0;
}

.label {
  margin-top: 1.5rem;
}

.address-table td {
  min-width: 12rem;
  padding: 0.5rem 0.5rem;
}

.address-table th,
td {
  padding: 0 0.5rem;
  border-bottom: 0.5px solid #dae8f6;
}

.radio-td {
  min-width: 3rem !important;
}

.address-action {
  min-width: 5rem !important;
}

.table-wrapper {
  overflow-x: auto;
}

.address-table input {
  margin-bottom: 0;
}
</style>
